<div class="page-layout blank p-12" fusePerfectScrollbar>

    <div *ngIf="!unregisteredNew">
        <h1>Ficha para Agendamento</h1>
        <form [formGroup]="pacienteForm" name="pacienteform">

            <div fxLayout="row">
                <mat-form-field class="w-50-p mr-8" appearance="outline">
                    <mat-label>CPF</mat-label>
                    <input matInput id="personCpf" formControlName="personCpf" mask="000.000.000-00"
                        (blur)="validateCpf()"/>
                </mat-form-field>


                <mat-form-field class="w-50-p" appearance="outline">
                    <mat-label>Data Nascimento</mat-label>
                    <input type="text" formControlName="personBirthday" matInput mask="d0/M0/0000"
                        [dropSpecialCharacters]="false" />
                </mat-form-field>
            </div>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Nome</mat-label>
                <input formControlName="personName" matInput id="personName" />
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Celular</mat-label>
                <input formControlName="personPhone" matInput mask="(00) 0 0000-0000" />
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input formControlName="personTel" matInput mask="(00) 0000-0000" />
            </mat-form-field>

        </form>

        <mat-form-field class="w-100-p" appearance="outline">
            <mat-label>Convênio</mat-label>
            <input type="text" placeholder="Nome" aria-label="Number" matInput [formControl]="insuranceControl"
                [matAutocomplete]="auto2" (ngModelChange)="getProcedureList()" />
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let insurance of insuranceList" [value]="insurance">
                    {{ insurance.name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="w-100-p" appearance="outline">
            <mat-label>Unidade</mat-label>
            <mat-select name="unit" [formControl]="unitControl"
                (ngModelChange)="getProcedureList(); getProfessionalList()">
                <div>
                    <mat-option *ngFor="let unit of unitList" [value]="unit">
                        {{ unit.name }}
                    </mat-option>
                </div>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="unitControl.value?.id && insuranceControl.value?.id" class="w-100-p"
            appearance="outline">
            <mat-label>Especialidade</mat-label>
            <input type="text" placeholder="Nome" aria-label="Nome" matInput [formControl]="specialityControl"
                [matAutocomplete]="auto" (ngModelChange)="getProfessionalList()" />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let speciality of specialityList" [value]="speciality">
                    {{ speciality.name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>


        <div *ngIf="specialityControl.value?.id">
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Profissional</mat-label>
                <input type="text" placeholder="Nome" aria-label="Number" matInput [formControl]="professionalControl"
                    [matAutocomplete]="auto" (ngModelChange)="getProcedureList()" />
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnProfessional">
                    <mat-option *ngFor="
                let professional of professionalList
            " [value]="professional">
                        {{ professional.performerName }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <mat-form-field class="w-100-p" appearance="outline" *ngIf="this.prepareProcedureControl.value">
            <mat-label>Preparo</mat-label>
            <textarea matInput placeholder="Preparo" [formControl]="prepareProcedureControl"
                readonly="readonly"></textarea>
        </mat-form-field>


        <mat-form-field class="w-100-p" appearance="outline">
            <mat-label>Observação</mat-label>
            <textarea matInput placeholder="Obs.." [formControl]="observableControl"></textarea>
        </mat-form-field>

        <div style="bottom: 0; right: 0" fxLayout="row" class="mb-12">
            <div class="ml-8">
                <button id="newScheduleButton" color="accent" matTooltip="Buscar agenda" mat-raised-button
                    class="mr-sm-12" (click)="getScheduleeList()" [disabled]="loadingSchedule">
                    <ng-container *ngIf="!loadingSchedule; else loadingTpl">
                        Buscar agenda
                    </ng-container>
                    <ng-template #loadingTpl>
                        <div class="spinner-center">
                            <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"
                                strokeWidth="3"></mat-progress-spinner>
                        </div>
                    </ng-template>
                </button>
            </div>
        </div>

        <div class="schedule-container" #scheduleContainer>
            <mat-card *ngFor="let group of groupedSchedules" class="schedule-card" appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        <span class="date-text">{{ group.date | date:'EEEE, dd/MM/yyyy' }}</span>
                    </mat-card-title>
                </mat-card-header>

                <mat-card-content>
                    <div *ngFor="let perf of group.performers" class="performer-block">
                        <div class="performer-info">
                            <div class="performer-name">{{ perf.performerName }}</div>
                            <div class="speciality">{{ perf.specialityName }}</div>
                        </div>

                        <mat-chip-listbox class="chip-list" aria-label="Horários disponíveis">
                            <mat-chip-option *ngFor="let item of perf.hours" color="primary"
                                (click)="handleSchedule(item)">
                                {{ item.hour }}
                            </mat-chip-option>
                        </mat-chip-listbox>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div style="bottom: 0; right: 0" fxLayout="row" class="mb-12" *ngIf="scheduleList.length > 0">
            <div class="ml-8">
                <button id="newScheduleButton" color="accent" matTooltip="Buscar agenda" mat-raised-button
                    class="mr-sm-12" (click)="getScheduleeList(50)" [disabled]="loadingSchedule">
                    <ng-container *ngIf="!loadingSchedule; else loadingMoreTpl">
                        Buscar mais
                    </ng-container>
                    <ng-template #loadingMoreTpl>
                        <div class="spinner-center">
                            <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"
                                strokeWidth="3"></mat-progress-spinner>
                        </div>
                    </ng-template>
                </button>
            </div>
        </div>

    </div>

    <div *ngIf="unregisteredNew">

        <app-unregistered-new></app-unregistered-new>

    </div>

</div>
